
import {
    onMounted,
    ref,
    defineAsyncComponent,
 } from 'vue';

import useSucursales from '@/modules/administracion/composables/useSucursales';

export default {
    components: {
        SucursalEditarComponent: defineAsyncComponent(
            () => import('@/modules/administracion/components/SucursalEditarComponent.vue')
        ),
    },
    setup() {
        const {
            obtenerSucursales,
            cambiarEstadoSucursal,
        } = useSucursales();

        const fitroBusqueda = ref<any>({
            textoBuscar: ''
        });

        const headers = [
            { text: 'Ciudad', value: 'ciudad', sortable: true },
            { text: 'Zona', value: 'zona', sortable: true },
            { text: 'Dirección', value: 'direccion', sortable: true },
            { text: 'Estado', value: 'estado', sortable: true },
            { text: '', value: 'acciones', width: 15 },
        ];

        let sucursales: any = [];
        const sucursalesFiltradas = ref<any[]>([]);

        const textoFiltro = ref<string>('');

        const sucursalEditarComponentRef = ref();

        onMounted(async () => {
            await buscarSucursales();
        });

        const buscarSucursales = async () => {
            const resp = await obtenerSucursales(fitroBusqueda.value.textoBuscar);
            if (resp.ok) {
                sucursales = resp.data;
                sucursalesFiltradas.value = JSON.parse(JSON.stringify(sucursales));
            }
        }

        const nuevaSucursal = async () => {
            sucursalEditarComponentRef.value.abrirComponent();
        }

        const editarSucursal = async (sucursal: any) => {
            sucursalEditarComponentRef.value.abrirComponent(sucursal.id_sucursal);
        }

        const alternarEstadoSucursal = async (sucursal: any) => {
            const resp = await cambiarEstadoSucursal(sucursal.id_sucursal, !sucursal.estado);
            if (resp.ok) {
                await buscarSucursales();
            }
        }

        const filtrarInformacion = async () => {
            sucursalesFiltradas.value = JSON.parse(JSON.stringify(
                sucursales.filter(
                    (s: any) =>
                        s.ciudad.toLowerCase().includes(textoFiltro.value.toLowerCase()) ||
                        s.zona.toLowerCase().includes(textoFiltro.value.toLowerCase()) ||
                        s.direccion.toLowerCase().includes(textoFiltro.value.toLowerCase())
                )
            ));
        }

        const cerrarEditarSucursalComponentEmit = async (seGrabo: boolean) => {
            if (seGrabo) {
                await buscarSucursales();
            }
        }

        return {
            fitroBusqueda,
            headers,
            textoFiltro,
            sucursalesFiltradas,

            buscarSucursales,
            editarSucursal,
            alternarEstadoSucursal,
            filtrarInformacion,
            nuevaSucursal,

            sucursalEditarComponentRef,
            cerrarEditarSucursalComponentEmit,
        };
    }
}
